import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Layout } from "../Components/Layout";
import { useUsuario } from "../Hooks/UsuarioHook";
import { AdicionarSistema } from "../Pages/App/AdicionarSistema";
import { Perfil } from "../Pages/App/Perfil/index";
import { PerfilForm } from "../Pages/App/Perfil/PerfilForm";
import { SistemasLiberados } from "../Pages/App/SistemasLiberados";
import { Usuarios } from "../Pages/App/Usuarios";

import { app_base_url } from "../Utils/Urls";
import { podeCriarSistema } from "../Utils/permissoes";

export function AppRoutes() {
  const { usuario } = useUsuario();

  return (
    <Router>
      <Layout>
        <Routes>
        {/* Rota do perfil */}
        <Route path={`${app_base_url}/perfil`} element={<Perfil />} />

        {usuario.usuario.administrador && (
          <>


            {/* Cadastro de sistemas: liberado só para os CPFs de manutenção */}
            {podeCriarSistema(usuario.usuario) && (
              <>
                <Route
                  path={`${app_base_url}/criar-sistema`}
                  element={<AdicionarSistema />}
                />
                <Route
                  path={`${app_base_url}/criar-sistema/:id`}
                  element={<AdicionarSistema />}
                />
              </>
            )}

            {/* Rota para usuários */}
            <Route path={`${app_base_url}/usuarios`} element={<Usuarios />} />
          </>
        )}

        {/* Cadastro de usuário: ADMINISTRADOR ou SERVIDOR.
            Antes existia só dentro do bloco do `servidor`, então um administrador
            que não fosse servidor caía na rota coringa e voltava para a home.
            Declarada UMA vez aqui para não repetir a mesma rota em dois blocos.
            A entidade NÃO é escolhida nesta tela: o Perfil força o entidade_id do
            token de quem está logado (ver Perfil/index.tsx, salvar()). */}
        {(usuario.usuario.administrador || usuario.usuario.servidor) && (
          <Route path={`${app_base_url}/criar-usuario`} element={<Perfil />} />
        )}

        {/* Rota de perfil com ID */}
        {/* <Route
          path={`${app_base_url}/perfil/:id_usuario`}
          element={<Perfil />}
        /> */}
        {usuario.usuario.administrador && (
          <Route
            path={`${app_base_url}/perfil/:id_usuario`}
            element={<Perfil />}
          />
        )}

        {/* /criar-usuario saiu daqui — está declarada acima, para administrador
            OU servidor, sem duplicar a rota. */}
        {usuario.usuario.servidor && (
          <Route path={`${app_base_url}/usuarios`} element={<Usuarios />} />
        )}
        {/* Rota de sistema com ID */}
        <Route
          path={`${app_base_url}/sistema/:sistema_id`}
          element={<Usuarios />}
        />

        {/* Rota coringa */}
        <Route path={`${app_base_url}/*`} element={<SistemasLiberados />} />
        </Routes>
      </Layout>
    </Router>
  );
}
